import { EmpresasEPessoasPage } from './EmpresasEPessoasPage.tsx'

/**
 * Empresas como MODULO da barra lateral (pedido do usuario 2026-08-25). Desde
 * a SPEC-20261010-1216-empresas-e-pessoas-num-icone, é a aba Empresas do ícone "Empresas e pessoas".
 */
export function CompaniesPage() {
  return <EmpresasEPessoasPage aba="empresas" />
}
